export var NON_CALLABLE_HOOKS;
(function (NON_CALLABLE_HOOKS) {
    NON_CALLABLE_HOOKS["query"] = "query";
})(NON_CALLABLE_HOOKS || (NON_CALLABLE_HOOKS = {}));
//# sourceMappingURL=index.js.map